import { stringify } from 'qs';
import request from '../../../../../services/request';
import { url } from '../service-utils';

/**
 * 获取可以匹配的字段列表
 * 页面：教师导入
 * 前端：刘杰
 * 后端：夏劲峰
 */
export async function getMatchTitleList(params) {
  return request(`${url.url}/import/teacher/getMatchTitleList?${stringify(params)}`);
}

/**
 * 获取同名部门列表
 * 页面：教师导入
 * 前端：刘杰
 * 后端：夏劲峰
 */
export async function getSameNameDeptList(params) {
  return request(`${url.url}/import/teacher/getSameNameDeptList?${stringify(params)}`);
}

/**
 * 匹配同名部门
 * 页面：教师导入
 * 前端：刘杰
 * 后端：夏劲峰
 */
export async function matchSameNameDept(params) {
  return request(`${url.url}/import/teacher/matchSameNameDept`, {
    method: 'post',
    data: params,
  });
}

/**
 * 获取同名人员列表
 * 页面：教师导入
 * 前端：刘杰
 * 后端：夏劲峰
 */
export async function getSameNameUserList(params) {
  return request(`${url.url}/import/teacher/getSameNameUserList?${stringify(params)}`);
}

/**
 * 忽略同名人员
 * 页面：教师导入
 * 前端：刘杰
 * 后端：夏劲峰
 */
export async function ignoreUser(params) {
  return request(`${url.url}/import/teacher/ignore`, {
    method: 'post',
    data: params,
  });
}

/**
 * 合并同名人员
 * 页面：教师导入
 * 前端：刘杰
 * 后端：夏劲峰
 */
export async function mergeUser(params) {
  return request(`${url.url}/import/teacher/merge`, {
    method: 'post',
    data: params,
  });
}

/**
 * 覆盖同名人员
 * 页面：教师导入
 * 前端：刘杰
 * 后端：夏劲峰
 */
export async function coverUser(params) {
  return request(`${url.url}/import/teacher/replace`, {
    method: 'post',
    data: params,
  });
}

/**
 * 保存表头匹配结果
 * 页面：教师导入
 * 前端：刘杰
 * 后端：夏劲峰
 */
export async function saveMatchTitle(params) {
  return request(`${url.url}/import/teacher/saveMatchTitle`, {
    method: 'post',
    data: params,
  });
}
